<template>
    <router-link id="logo" :to="{name: 'Siakad'}" class="r-center-flex">
        <div class="r-wd-40-max r-mr-8">
            <img :src="require('@/assets/siakad.svg')" alt="siakad" class="r-isExpand">
        </div>
        <strong>SIAKAD </strong> <span class="r-ml-4">Masehi</span>
    </router-link>
</template>